/**
 * Created by baiqi.li on 2018/11/19.
 */

import Logic from '@/logic/logic-base'
const repertoryBiz = new Logic()

repertoryBiz.deleteInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.repertory.deleteInstance,
    data: data
  })
}

repertoryBiz.getInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.repertory.getInstance,
    data: data
  })
}

repertoryBiz.saveInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.repertory.saveInstance,
    data: data
  })
}

repertoryBiz.updateInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.repertory.updateInstance,
    data: data
  })
}

repertoryBiz.getS3Record = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.repertory.getS3Record,
    data: data
  })
}

export default repertoryBiz
